import React from "react";
import { size, uniqueId } from "lodash";
import { IllustrationProps } from ".";

const uid = uniqueId();

export default ({
  colors: {
    base,
    scheme,
    chart: { primary },
  },
}: IllustrationProps) => {
  const numberOfColors = size(scheme);
  const _scheme = numberOfColors === 0 ? [primary] : scheme;

  return (
    <svg width="100%" height="100%" viewBox="0 0 60 60">
      <defs>
        <mask id={"center" + uid}>
          <rect width="100%" height="100%" fill="#FFF" />
          <circle cx={30} cy={30} r={16} />
        </mask>
        <clipPath id={"donut" + uid}>
          <circle cx={30} cy={30} r={30} fill="#FFF" />
        </clipPath>
      </defs>

      <g mask={`url(#center${uid})`} clipPath={`url(#donut${uid})`}>
        {/* Sector 4 */}
        <rect
          x={0}
          y={0}
          width={30}
          height={60}
          fill={_scheme[3] || _scheme[1] || base}
        />
        {/* Sector 3 */}
        <rect
          x={0}
          y={30}
          width={30}
          height={30}
          fill={_scheme[2] || _scheme[1] || base}
        />
        {/* Sector 2 */}
        <rect
          x={30}
          y={30}
          width={30}
          height={30}
          fill={_scheme[2] ? _scheme[1] : _scheme[0]}
          transform="rotate(60)"
          transform-origin="30 30"
        />
        {/* Sector 1 */}
        <rect x={30} y={0} width={30} height={60} fill={_scheme[0]} />
      </g>
    </svg>
  );
};
